"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4090],{

/***/ 11856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ FaTimes; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaTimes(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 352 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 98851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ GenIcon; }
});

// UNUSED EXPORTS: IconBase

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/atoms/Icon/iconContext.js
/* eslint-disable */

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && /*#__PURE__*/(0,react.createContext)(DefaultContext);
;// CONCATENATED MODULE: ./components/atoms/Icon/iconBase.js
/* eslint-disable */
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, _p = Object.getOwnPropertySymbols(s); i < _p.length; i++) {
    if (e.indexOf(_p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, _p[i])) t[_p[i]] = s[_p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return /*#__PURE__*/(0,react.createElement)(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function IconBase(props) {
  var elem = function elem(conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /*#__PURE__*/(0,react.createElement)("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /*#__PURE__*/(0,react.createElement)("title", null, title), props.children);
  };

  return IconContext !== undefined ? /*#__PURE__*/(0,react.createElement)(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
} // export function GenIcon({ data, ...props }) {
//   return React.createElement(
//     IconBase,
//     __assign(
//       {
//         attr: __assign({}, data.attr),
//       },
//       props
//     ),
//     Tree2Element(data.child)
//   );
// }

function GenIcon(data) {
  return function Generate(props) {
    return /*#__PURE__*/(0,react.createElement)(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
} // export const IconKhoa = (props) => {
//   return (
//     <GenIcon
//       data={{
//         tag: "svg",
//         attr: { viewBox: "0 0 1024 1024" },
//         child: [
//           {
//             tag: "path",
//             attr: {
//               d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z",
//             },
//           },
//         ],
//       }}
//       {...props}
//     />
//   );
// };

/***/ }),

/***/ 97464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91164);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40037);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["image", "src", "alt", "placeholder", "priority", "wrapper", "width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var _getConfig = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var publicOptions = publicRuntimeConfig.publicOptions;

var path = __webpack_require__(26470);
/** ========== */

/**
 *
 * @param {{
 * image;
 * src;
 * alt;
 * placeholder;
 * priority;
 * wrapper:{className,style};
 * width:String|Number;
 * heightString|Number;
 * }} props Props for the component
 *
 */


var ratioScreen = {
  sm: 375,
  md: 768,
  lg: 1920
};
var ratioRange = [0, ratioScreen.sm, ratioScreen.md, ratioScreen.lg];

var genImageHead = function genImageHead(width, height, src, ratio) {
  var ratioClone = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ratio);

  var imgHeadList = [];

  if (width <= ratioClone[0].width) {
    imgHeadList.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("link", {
      rel: "preload",
      href: "".concat(publicOptions.basePath, "/").concat(src, "-").concat(width, "x").concat(height, ".webp"),
      as: "image",
      type: "image/webp",
      media: "(min-width: ".concat(ratioRange[0], "px) and (max-width: ").concat(ratioRange[1] - 1, "px)")
    }, 0));
  } else {
    for (var index = 0; index < ratioClone.length; index++) {
      var element = ratioClone[index]; // Width của image lớn hơn width của màn hình đang xét

      if (width >= element.width) {
        // Màn hình lớn nhất
        if (index === ratioClone.length - 1) {
          imgHeadList.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("link", {
            rel: "preload",
            href: "".concat(publicOptions.basePath, "/").concat(src, "-").concat(element.width, "x").concat(element.height, ".webp"),
            as: "image",
            type: "image/webp",
            media: "(min-width: ".concat(ratioRange[index], "px) ")
          }, index));
        } else {
          // Không phải màn hình lớn nhất
          imgHeadList.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("link", {
            rel: "preload",
            href: "".concat(publicOptions.basePath, "/").concat(src, "-").concat(element.width, "x").concat(element.height, ".webp"),
            as: "image",
            type: "image/webp",
            media: "(min-width: ".concat(ratioRange[index], "px) and (max-width: ").concat(ratioRange[index + 1] - 1, "px)")
          }, index));
        }
      } else if ( // Width của image nằm giữa width màn hình đang xét và width màn hình trước đó
      width > ratioClone[index - 1].width && width <= ratioClone[index].width) {
        imgHeadList.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("link", {
          rel: "preload",
          href: "".concat(publicOptions.basePath, "/").concat(src, "-").concat(width, "x").concat(height, ".webp"),
          as: "image",
          type: "image/webp",
          media: "(min-width: ".concat(ratioRange[index], "px) ")
        }, index));
      }
    }
  }

  return imgHeadList.reverse();
};

var genImageSource = function genImageSource(width, height, src, ratio) {
  var ratioClone = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ratio);

  var imgSourceList = [];

  if (width <= ratioClone[0].width) {
    imgSourceList.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
      type: "image/webp",
      srcSet: "".concat(publicOptions.basePath, "/").concat(src, "-").concat(width, "x").concat(height, ".webp"),
      media: "(min-width: 240px)"
    }, 0));
  } else {
    for (var index = 0; index < ratioClone.length; index++) {
      var element = ratioClone[index]; // Width của image lớn hơn kích thước của màn hình đang xét

      if (width >= element.width) {
        // Màn hình lớn nhất
        if (index === ratioClone.length - 1) {
          imgSourceList.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
            type: "image/webp",
            srcSet: "".concat(publicOptions.basePath, "/").concat(src, "-").concat(element.width, "x").concat(element.height, ".webp"),
            media: "(min-width: ".concat(ratioRange[index], "px)")
          }, index));
        } else {
          // Không phải màn hình lớn nhất
          imgSourceList.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
            type: "image/webp",
            srcSet: "".concat(publicOptions.basePath, "/").concat(src, "-").concat(element.width, "x").concat(element.height, ".webp"),
            media: "(min-width: ".concat(ratioRange[index], "px) and (max-width: ").concat(ratioRange[index + 1] - 1, "px)")
          }, index));
        }
      } else if ( // Width của image nằm giữa kích thước màn hình đang xét so với màn hình trước đó
      width > ratioClone[index - 1].width && width < ratioClone[index].width) {
        imgSourceList.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
          type: "image/webp",
          srcSet: "".concat(publicOptions.basePath, "/").concat(src, "-").concat(width, "x").concat(height, ".webp"),
          media: "(min-width: ".concat(ratioRange[index], "px)")
        }, index));
      }
    }
  }

  return imgSourceList.reverse();
};

var Img = function Img(_ref) {
  var image = _ref.image,
      src = _ref.src,
      alt = _ref.alt,
      placeholder = _ref.placeholder,
      priority = _ref.priority,
      wrapper = _ref.wrapper,
      width = _ref.width,
      height = _ref.height,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var srcStatic = src ? src.replace(/^\/+/, "") : placeholder.replace(/^\/+/, "");

  if (image && image.constructor === Object && Object.keys(image).length !== 0) {
    var _publicOptions$option, _publicOptions$option2, _image$mediaDetails5, _image$mediaDetails6;

    var webpEnable = publicOptions === null || publicOptions === void 0 ? void 0 : (_publicOptions$option = publicOptions.options) === null || _publicOptions$option === void 0 ? void 0 : (_publicOptions$option2 = _publicOptions$option.acf) === null || _publicOptions$option2 === void 0 ? void 0 : _publicOptions$option2.webpEnable;

    if (webpEnable) {
      var _image$mediaDetails, _image$mediaDetails2, _image$mediaDetails3, _image$mediaDetails4;

      var srcSet = [];
      var originalSize = "".concat(image === null || image === void 0 ? void 0 : image.sourceUrl, ".webp ").concat(image === null || image === void 0 ? void 0 : (_image$mediaDetails = image.mediaDetails) === null || _image$mediaDetails === void 0 ? void 0 : _image$mediaDetails.width, "w");
      srcSet.push(originalSize);
      var sizes = (image === null || image === void 0 ? void 0 : (_image$mediaDetails2 = image.mediaDetails) === null || _image$mediaDetails2 === void 0 ? void 0 : _image$mediaDetails2.sizes) || [];

      if (sizes.length > 0) {
        sizes.forEach(function (size) {
          var newSize = "".concat(size === null || size === void 0 ? void 0 : size.sourceUrl, ".webp ").concat(size === null || size === void 0 ? void 0 : size.width, "w");
          srcSet.push(newSize);
        });
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread({}, wrapper), {}, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("picture", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", _objectSpread({
              type: "image/webp",
              srcSet: srcSet.join(", "),
              sizes: image === null || image === void 0 ? void 0 : image.sizes
            }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", _objectSpread(_objectSpread({}, props), {}, {
              loading: "".concat(priority ? null : "lazy"),
              decoding: "async",
              src: image === null || image === void 0 ? void 0 : image.sourceUrl,
              srcSet: image === null || image === void 0 ? void 0 : image.srcSet,
              sizes: image === null || image === void 0 ? void 0 : image.sizes,
              width: image === null || image === void 0 ? void 0 : (_image$mediaDetails3 = image.mediaDetails) === null || _image$mediaDetails3 === void 0 ? void 0 : _image$mediaDetails3.width,
              height: image === null || image === void 0 ? void 0 : (_image$mediaDetails4 = image.mediaDetails) === null || _image$mediaDetails4 === void 0 ? void 0 : _image$mediaDetails4.height,
              alt: image !== null && image !== void 0 && image.altText ? image === null || image === void 0 ? void 0 : image.altText : alt,
              title: image !== null && image !== void 0 && image.altText ? image === null || image === void 0 ? void 0 : image.altText : alt
            }))]
          })
        }))
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread({}, wrapper), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", _objectSpread(_objectSpread({}, props), {}, {
          loading: "".concat(priority ? null : "lazy"),
          decoding: "async",
          src: image === null || image === void 0 ? void 0 : image.sourceUrl,
          srcSet: image === null || image === void 0 ? void 0 : image.srcSet,
          sizes: image === null || image === void 0 ? void 0 : image.sizes,
          width: image === null || image === void 0 ? void 0 : (_image$mediaDetails5 = image.mediaDetails) === null || _image$mediaDetails5 === void 0 ? void 0 : _image$mediaDetails5.width,
          height: image === null || image === void 0 ? void 0 : (_image$mediaDetails6 = image.mediaDetails) === null || _image$mediaDetails6 === void 0 ? void 0 : _image$mediaDetails6.height,
          alt: image !== null && image !== void 0 && image.altText ? image === null || image === void 0 ? void 0 : image.altText : alt
        }))
      }))
    });
  }

  var extname = path.extname(srcStatic).toLowerCase();
  var isPng = extname.localeCompare(".png") == 0;
  var isJpeg = extname.localeCompare(".jpg") == 0 || extname.localeCompare(".jpeg") == 0;

  if (width && (isPng || isJpeg)) {
    var srcSplit = srcStatic === null || srcStatic === void 0 ? void 0 : srcStatic.split(".")[0];
    var srcArr = srcSplit === null || srcSplit === void 0 ? void 0 : srcSplit.split("/");
    var srcOptimize = "assets/optimize-images/".concat(srcArr[srcArr.length - 1]);
    var ratioSm = ratioScreen.sm / width;
    var ratioMd = ratioScreen.md / width;
    var ratioLg = ratioScreen.lg / width;
    var sm = {
      width: ratioScreen.sm,
      height: Math.round(ratioSm * height)
    };
    var md = {
      width: ratioScreen.md,
      height: Math.round(ratioMd * height)
    };
    var lg = {
      width: ratioScreen.lg,
      height: Math.round(ratioLg * height)
    };
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: [priority && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: genImageHead(width, height, srcOptimize, [sm, md, lg]).map(function (item) {
          return item;
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread({}, wrapper), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("picture", {
          children: [genImageSource(width, height, srcOptimize, [sm, md, lg]).map(function (item) {
            return item;
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", _objectSpread({
            loading: "".concat(priority ? null : "lazy"),
            decoding: "async",
            src: "".concat(publicOptions.basePath, "/").concat(srcStatic),
            alt: alt,
            width: width,
            height: height
          }, props))]
        })
      }))]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [priority && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("link", {
        rel: "preload",
        as: "image",
        href: "".concat(publicOptions.basePath, "/").concat(srcStatic)
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread({}, wrapper), {}, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", _objectSpread({
        loading: "".concat(priority ? null : "lazy"),
        decoding: "async",
        src: "".concat(publicOptions.basePath, "/").concat(srcStatic),
        alt: alt,
        width: width,
        height: height
      }, props))
    }))]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Img);
Img.defaultProps = {
  wrapper: {
    className: "inline-block"
  },
  src: null,
  priority: false,
  placeholder: "assets/common/placeholder.jpg",
  image: {},
  alt: "placeholder"
};

/***/ }),

/***/ 56677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Cookies; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/fa/FaCookieBite.js

function FaCookieBite(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/common/Layout/Cookies.js






function Cookies() {
  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  var handleCookiesClick = function handleCookiesClick() {
    localStorage.setItem("statusPopup", 1);
    localStorage.setItem("expirationCookies", new Date().getTime());
    setShow(false);
  };

  (0,react.useEffect)(function () {
    var timer = setTimeout(function () {
      var statusPopup = localStorage.getItem("statusPopup");
      var expirationCookies = localStorage.getItem("expirationCookies");

      if (!statusPopup || Number.parseInt(statusPopup, 10) !== 1 || !expirationCookies || new Date().getTime() - expirationCookies > 7 * 86400000) {
        setShow(true);
      }
    }, 15000);
    return function () {
      return clearTimeout(timer);
    };
  }, []);
  return show ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "fixed bottom-12 left-4 right-4 z-50   md:left-12 md:max-w-[563px] ",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "rounded-xl bg-white py-6 px-4 text-black drop-shadow-[0px_0px_20px_rgba(124,120,120,0.2)] md:flex md:items-center ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: "md:pr-6",
        children: ["By using our website you consent to all cookies in accordance with our", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
          href: "/privacy-policy",
          className: "text-bbc-primary",
          target: "_blank",
          rel: "nofollow",
          children: "Privacy Policy"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        onClick: handleCookiesClick,
        className: "mt-2 whitespace-nowrap rounded-full bg-bbc-primary py-2 px-6 font-semibold text-white md:mt-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCookieBite, {
          size: 16,
          className: "mr-2 inline-block"
        }), "Accept"]
      })]
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

/***/ })

}]);